module.exports = __webpack_public_path__ + "static/media/CC20-AP090-12-FAICO.86d3093e.pdf";